import {
  getActiveLocations,
  getLicenses,
  Licenses,
  LicenseTypes,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";

import { useCompany } from "./useCompany";

export function useLocationsWithLicenses(moduleName: LicenseTypes) {
  const { company } = useCompany();

  const { data: locations } = useQuery({
    queryKey: ["locations", company?.companyId],
    queryFn: () => getActiveLocations(company?.companyId ?? ""),
    enabled: !!company?.companyId,
  });

  const { data: licenses, isPending } = useQuery({
    queryKey: ["locationLicenses"],
    queryFn: () => getLicenses(locations ?? []),
    enabled: !!locations,
  });

  const flattenedLicenses =
    licenses?.flat().flatMap((license) => license.data) || [];

  const mergedLocations = locations?.map((location) => {
    const matchingLicenses = flattenedLicenses.filter(
      (license) => license.companyLocationId === location.id,
    );

    return {
      ...location,
      licenses: {
        data: matchingLicenses,
        success: true,
      } as Licenses,
    };
  });

  return {
    locations: mergedLocations?.filter((l) =>
      l.licenses.data.some((d) => {
        return d.moduleName === moduleName;
      }),
    ),
    isPending: isPending || !locations,
  };
}
